












































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import VatsAPI from '@/Shared/VatsAPI';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { Dictionary } from 'vue-router/types/router';
import BuildEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { EXactPageKeys } from './EXactPageKeys';
import { AxiosResponse } from 'axios';
import RadioToggle from '@/Shared/RadioToggle.vue';
import { supportedLocales } from '@/internationalization';
import { E_XactPaymentType } from '@/Payment/Enums';

const component = mixins(LocationBasedMixin, BuildEntityListComponent<EXactPageKeys>()).extend({
    components: {
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.programVariables.payments.processorConfig.e_xact',
            E_XactPaymentType,
            E_XactPaymentTypeNumericKeys: Object.keys(E_XactPaymentType)
                .filter(k => typeof (E_XactPaymentType as any)[k] !== 'number')
        };
    },
    computed: {
        entityUrls() {
            return `${this.location}/Payments/EXactPageKeys`;
        },
        localeOptions() {
            return Object.values(supportedLocales);
        }
    },
    methods: {
        afterSave(response: AxiosResponse<EXactPageKeys>): EXactPageKeys {
            this.$emit('credentialsUpdated');

            return response.data;
        },
    }
});

export default component;
